import React from 'react';
import { Controller } from 'react-hook-form';
import { TextField } from '@mui/material';

const focusedBorderStyle = {
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#4AB3BC',
    },
  },
};

// 사용자 입력을 숫자로 파싱. 빈 입력은 '', 숫자 외 문자가 섞이면 null(=무시).
const parseNumericInput = rawInput => {
  if (rawInput === '') return '';
  if (!/^[0-9]+$/.test(rawInput)) return null;
  return Number(rawInput);
};

export const FormInputNumber = ({
  name = '',
  control,
  rules,
  disabled,
  label,
  placeholder,
  type = 'text',
  size,
  sx,
  className,
  id,
  inputProps,
  InputProps,
  onChange,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { onChange: formOnChange, value }, fieldState: { error } }) => {
        const handleChange = e => {
          const parsed = parseNumericInput(e.target.value);
          // 숫자 외 문자 입력은 폼 갱신 차단 (입력이 무시됨)
          if (parsed === null) return;
          formOnChange({ ...e, target: { ...e.target, value: parsed } });
          if (onChange) onChange(e);
        };

        return (
          <TextField
            id={id}
            name={name}
            value={value ?? ''}
            type={type}
            disabled={disabled}
            label={label}
            placeholder={placeholder}
            error={!!error}
            helperText={error ? error.message : null}
            onChange={handleChange}
            size={size}
            fullWidth
            variant="outlined"
            className={className}
            inputProps={inputProps}
            InputProps={InputProps}
            sx={{ ...focusedBorderStyle, ...sx }}
          />
        );
      }}
    />
  );
};
